// MarginDropLine.jsx - Pure presentation component for drop indicator
import React from 'react';
import DimensionsConstants from 'constants/DimensionsConstants';
import ColorConstants from 'constants/ColorConstants';

function MarginDropLine({ show, canDrop, depth, isTop = false }) {
  // Calculate indentation based on depth
  const marginLeft = (depth || 0) * 30;
  
  // Only show line if it's a valid drop (or not showing at all)
  const shouldDisplay = show && canDrop;
  const opacity = shouldDisplay ? 1 : 0;
  
  return (
    <div
      style={{
        height: '5px',  // Restored original thickness
        width: DimensionsConstants.CODE_LABEL_WIDTH,
        marginLeft: `${marginLeft}px`,
        backgroundColor: ColorConstants.GHOST_COLOR,
        opacity,
        marginTop: isTop ? '2px' : '-8px',  // Don't pull up if it's the top zone
        marginBottom: '3px'  // Add some space below
      }}
    />
  );
}

export default MarginDropLine;